export enum UserType {
  REGISTERED = 'Registered',
  ANONYMOUS = 'Anonymous',
}
